module.exports = function () {
    const dropdowns = document.querySelectorAll('#menu-header-menu > .menu-item-has-children > a'),
        navbarContainer = document.querySelector('#site-header .site-header-container'),
        designedUlWidth = 344, // Element witdh form designs
        isMobile = window.matchMedia("(max-width: 1279px)");


    const setMenuItemListener = (item) => {
        if (isMobile.matches) {
            item.addEventListener("click", handleMenuClick, false);
            hideAllMenus();
        } else {
            item.removeEventListener("click", handleMenuClick, false);
            showAllMenus();
        }
    }

    if (isMobile.matches) {
        for (const dropdown of dropdowns) {
            jQuery(dropdown.nextElementSibling).slideUp(0);
        }
    }


    const handleMenuClick = (event) => {
        event.preventDefault();
        showCurrentMenu(event.target, event.target.nextElementSibling)
    }


    for (const dropdown of dropdowns) {
        setMaxDropdownWidth(dropdown, dropdown.nextElementSibling);
        setMenuItemListener(dropdown);
    };

    function showCurrentMenu(menuItem, sibling) {
        hideAllMenus(sibling);
        jQuery(sibling).slideToggle(300);
    }

    function showAllMenus() {
        for (const dropdown of dropdowns) {
            jQuery(dropdown.nextElementSibling).slideDown(0);
        }
    }

    function hideAllMenus(elemToSkip = null) {
        if (elemToSkip != null) {
            for (const dropdown of dropdowns) {
                if (elemToSkip != dropdown.nextElementSibling) {
                    jQuery(dropdown.nextElementSibling).slideUp(300);
                }
            }
        } else {
            for (const dropdown of dropdowns) {
                jQuery(dropdown.nextElementSibling).slideUp(300);
            }
        }
    }

    function setMaxDropdownWidth(item, dropdown) {
        const containerOffset = navbarContainer.getBoundingClientRect().right,
            ulOffset = item.getBoundingClientRect().left,
            result = containerOffset - ulOffset;

        if (result > designedUlWidth) {
            dropdown.classList.add('toLeft');
            dropdown.classList.remove('toRight');
        } else {
            dropdown.classList.add('toRight');
            dropdown.classList.remove('toLeft');
        }
    }

    // Hide on Scroll variables
    const navbar = document.querySelector('#site-header');

    let currentScrollTop = 0,
        c;


    // Mobile menu burger
    const burger = document.querySelector('#site-header .burger'),
        mobileMenu = document.querySelector('#site-header .menu-holder');

    var isMenuShowed = true;

    window.addEventListener('scroll', () => {
        isMenuShowed = true;
        burger.classList.remove('isActive');
        mobileMenu.classList.remove('isActive');


        const navHeight = navbar.offsetHeight,
            scrollPos = window.pageYOffset | document.body.scrollTop;

        currentScrollTop = scrollPos;

        if (c < scrollPos && currentScrollTop > 60) {
            navbar.classList.add("-translate-y-full");
            // console.log('hide navbar');
        } else if (currentScrollTop < 60) {
            // console.log('add transparency');
        } else if (c > currentScrollTop && !(scrollPos <= navHeight)) {
            // console.log('show navbar');
            navbar.classList.remove("-translate-y-full");
        }

        c = currentScrollTop;
    })

    burger.addEventListener("click", function () {
        isMenuShowed = !isMenuShowed;

        if (isMenuShowed) {
            burger.classList.remove('isActive');
            mobileMenu.classList.remove('isActive');
        } else {
            burger.classList.add('isActive');
            mobileMenu.classList.add('isActive');
        }
    }, false);

    // Reset Menu on page resize 
    window.addEventListener('resize', () => {
        isMenuShowed = true;
        mobileMenu.classList.remove('isActive');
        burger.classList.remove('isActive');

        for (const dropdown of dropdowns) {
            setMenuItemListener(dropdown);
        };
    });
}